import http from '../http-common';
import { withRunParam } from './analysisRunOptions';

class GestureSummaryService {
  /**
   * Fetch aggregated gesture statistics for one analysis.
   * @param {'interview'|'manual_analysis'} sourceType
   * @param {number} sourceId
   * @param {string|null} run - Optional run id (`?run=`); omitted -> active run
   */
  get(sourceType, sourceId, run = null) {
    return http.get(`/gesture-summary/${sourceType}/${sourceId}`, {
      params: withRunParam({}, run),
    });
  }
}

export default new GestureSummaryService();
